// Served from frontend/public/zaror-logo.png (source: ChatGPT Image Jun 15, 2026, 04_18_34 PM.png)
export const ZAROR_LOGO_PATH = '/zaror-logo.png';
export const ZAROR_OG_IMAGE_PATH = '/zaror-og.png';
export const ZAROR_OG_IMAGE_WIDTH = 1200;
export const ZAROR_OG_IMAGE_HEIGHT = 630;
